/*
 * @Author: Merlin
 * @Date: 2024-09-27 16:33:57
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-27 10:24:31
 * @Description: 
 */

import { useUserStore } from '~/stores/user'; 
import useGlobalStore from '@/stores/global'; 
import {useWavesSocket} from '@/socket/game/waves'; 
import {HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs'; 
import {
    oTickOptions,
    iDaySeconds,
    oChartConfig01_tt,
    oLongShort,
    oPnlFlat,
    oSpecialCoin, 
    WavesContractStateAll, 
    oTriggerType,
    oTable4Types,
    iDefaultMulti, 
} from '../ts/wavesData'; 
import {
    fnDelayPackageMaker, 
    fnDelayFnMaker, 
    fnPnlChecker,
} from '../ts/wavesFn'; 
import type {
    oPairsMap,
    ResTickData,
    AllPairsConfig,
} from '@/socket/game/dto/waves.dto';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';


// ------------------------------------------- 
const isDev = import.meta.dev;
const oTickOptions_M = oTickOptions;

// ↓ 初步判断认定为：游戏表单对象 
export const oWavesBetForm_a = reactive({ 
    ...{
        // 游戏右侧面板表单项 
        wager: 0.01, // 游戏加载时将被赋值 
        multi: iDefaultMulti, //
        feeType: oPnlFlat.pnl,  
        positionType: oLongShort.none,
    },
    ...{
        // 4大输入框用于建仓，4个输入框的值将实时同步到此 
        takeProfit: "", //
        takeProfitAmount: "", //
        stopLoss: "", //
        stopLossAmount: "", //
    },
    ...{
        // Update 家族，在修改已建仓时有使用到， 
        // 在修改仓时如果发现此处值和原始值不一样，表达已经被修改，这时点击确认按钮，允许用户点击保存  
        takeProfitUpdate: "", //
        takeProfitAmountUpdate: "", //
        stopLossUpdate: "", //
        stopLossAmountUpdate: "", //
        selectedTriggerLossUpdate: "" as oTriggerType, // 用于修改建仓
        selectedTriggerProfitUpdate: "" as oTriggerType, // 用于修改建仓
    },
    selectedTriggerLoss: "" as oTriggerType, // 建仓时需要提交 
    selectedTriggerProfit: "" as oTriggerType, // 建仓时需要提交 
    // == ↓其它（目前总结以下2项是建仓专用，修改时不用） =============== 
    isWagerError: false, // 在输入的 wager 值有误时会得到 true 
    isTakeStopError: false, // 在输入的止盈止损值有误时会得到 true 
}); 

// ↓ 执行后返回一个对象  
export const fnGameForm_Ot = ()=>{
    // ↓ 取得 true 表示输入正确可以建仓 
    // ↓ 仅限用于“建仓” 可能行的判断，“修改”不应使用这个 
    const isReady2Establish_u = computed(()=>{
        const bResult = (
            true
            && Number(oWavesBetForm_a.wager) > 0
            && Number(oWavesBetForm_a.multi) > 0
            && isFinite(Number(oWavesBetForm_a.takeProfit))
            && isFinite(Number(oWavesBetForm_a.stopLoss))
            && isFinite(Number(oWavesBetForm_a.takeProfitAmount))
            && isFinite(Number(oWavesBetForm_a.stopLossAmount))
            && !oWavesBetForm_a.isTakeStopError
            && !oWavesBetForm_a.isWagerError
        );
        return bResult; 
    });
    // ↓ 计算 position 总值（乘积）
    // ↓ 用途：short 型游戏时 
    // ↓ 此值 <= 对向输入值时显示提示： futures.errors.takeProfitNegative 止盈价格不能小于零（有点奇怪）  
    const positionAmount_n = computed(()=>{
        const aa= Number(oWavesBetForm_a.wager); 
        const bb = Number(oWavesBetForm_a.multi); 
        return aa * bb;
    });
    const fnSetTrigger = (
        isUpdating: boolean, 
        sType: 'win' | 'lose', // 止盈止损 
        sTriggerType: oTriggerType, // 触发类型 'value' | 'amount' 
    )=>{
        let sKey = ({
            win: 'selectedTriggerProfit',
            lose: 'selectedTriggerLoss',
        })[sType];
        if (isUpdating){
            sKey = ({
                win: 'selectedTriggerProfitUpdate',
                lose: 'selectedTriggerLossUpdate',
            })[sType];
        }
        oWavesBetForm_a[sKey] = sTriggerType;
    };
    const oResult = {
        controlsState: oWavesBetForm_a, // 其子项被解构，于（止盈止损输入框组件中） 
        isReady2Establish: isReady2Establish_u, // 布尔值 
        positionAmount: positionAmount_n, 
        // --- ↑ 提供一些数据 ------------------------  
        // --- ↓ 提供一些方法 ------------------------- 
        setWager: (newVal) => {
            oWavesBetForm_a.wager = newVal ?? "";
        },
        setMulti: (newVal) => {
            oWavesBetForm_a.multi = newVal ?? ""; 
        },
        setFeeType: (newVal) => {
            oWavesBetForm_a.feeType = newVal; 
        },
        setIsTakeStopError: (bNewValue) => { 
            // ↓ 记录是否输入值有误 
            oWavesBetForm_a.isTakeStopError = bNewValue; 
        },
        setWagerError: (newVal) => {
            oWavesBetForm_a.isWagerError = newVal; 
        },
        setPositionType: (newVal) => {
            oWavesBetForm_a.positionType = newVal; 
        },
        // ↓ 有关 🔶 trigger 相关的方法 ================================== 
        // ↓ 在此赋值后用于发送建仓和修改仓位时使用 
        setTakeProfit: (
            newIntVal, // 输入值 
            sTriggerType, // 输入类型  
            setUpdateVal=false, // 赋值目标 
        ) => {
            fnSetTrigger(setUpdateVal, 'win', sTriggerType);
            setUpdateVal
            ? oWavesBetForm_a.takeProfitUpdate = newIntVal ?? ""
            : oWavesBetForm_a.takeProfit = newIntVal ?? ""
        },
        setTakeProfitAmount: (newIntVal, sTriggerType, setUpdateVal=false) => {
            fnSetTrigger(setUpdateVal, 'win', sTriggerType);
            setUpdateVal
            ? oWavesBetForm_a.takeProfitAmountUpdate = newIntVal ?? ""
            : oWavesBetForm_a.takeProfitAmount = newIntVal ?? ""
        },
        // --- ↑ 止盈控制 ----------- 
        // --- ↓ 止损相关控制 ----------- 
        setStopLoss: (newIntVal, sTriggerType, setUpdateVal=false) => {
            fnSetTrigger(setUpdateVal, 'lose', sTriggerType);
            setUpdateVal
            ? oWavesBetForm_a.stopLossUpdate = newIntVal ?? ""
            : oWavesBetForm_a.stopLoss = newIntVal ?? ""
        },
        setStopLossAmount: (newIntVal, sTriggerType, setUpdateVal=false) => {
            fnSetTrigger(setUpdateVal, 'lose', sTriggerType);
            setUpdateVal
            ? oWavesBetForm_a.stopLossAmountUpdate = newIntVal ?? ""
            : oWavesBetForm_a.stopLossAmount = newIntVal ?? ""
        },
        // ↓ 六大皆空，全清空， 
        clearTakeStopInputs: () => {
            oWavesBetForm_a.takeProfit = "";
            oWavesBetForm_a.stopLoss = "";
            oWavesBetForm_a.takeProfitAmount = "";
            oWavesBetForm_a.stopLossAmount = "";
            oWavesBetForm_a.selectedTriggerLoss = oTriggerType.none; 
            oWavesBetForm_a.selectedTriggerProfit = oTriggerType.none; 
        },
    };
    return oResult;
}

// ==================================================================== 
// ========== ↑ 游戏的建仓表单 ================================================ 
// ========== ↓ 图表数据管理中心 ========================================== 
// ==================================================================== 

// ↓ 最终导出为： {chartState: chartState_r } 
export const chartState_r = reactive({
    stats24: { // 会被实时数据流不断地刷新 
        low: 0,
        high: 0,
        wager: 0,
    },
    data: [], // 重点数据, 保存多个 tick 数据，频繁更新 
    fundingRate: 0, 
    currentPairsPrices: null, // 这是保存币各种信息的对象 {}，包含最新价格，涨跌标记1/0等；在原版搜索 currentPairsPrices= 
    // ■■■■■ ↑ 以上数据被实时数据流“不断地” 刷新  ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ 
    selectedPair: "" as ('' | oPairsMap), // 示例 ETH_USDT、FuryWaves_USDT 默认为空，依据地址栏赋值 
    selectedTick: oTickOptions_M.Tick, // 将化为 rangeMs 被使用 
    chartType: oChartConfig01_tt.area, // 应该由 selectedTick 的值推导，这里项疑似价值不大 
    historyLoading: false, // true 表示数据加载中 
    isSubscribed: false, // 是否启用订阅的状态标记 
    chartMarkers: [], // 每日0点标记仓，仅在特殊币专用， 
});

let fnStoper = () => null; // 稍后被赋值 

// ↓ 导出
export const fnGetChartStateToolbox_oi = () => {
    const oWavesWs = useWavesSocket();
    // const {$i18n: u, $socketMediator: n, $notify: d} = et() 
    let hasLeftTheRoom = false; 
    const waveObj_l = ref(); // 在 tick 模式时被赋值一个对象 
    // ↓ 导出为 currentPriceByPair: currentPriceByPair_F 
    // ↓ 当前币最新点数值
    const currentPriceByPair_F = computed(() => { 
        const sKey01 = 'value';
        const sKey02 = 'close';
        const oLast = chartState_r.data.at(-1) || {};
        const fResult = (oLast[sKey01] ?? oLast[sKey02]) ?? 0; 
        // console.log("最新点数：", fResult);
        // ↓ 原版的取值方式，
        // const sKey = (
        //     chartState_r.chartType === oChartConfig01_tt.area 
        //     ? sKey01
        //     : sKey02
        // );
        // if (oLast[sKey] > 0 === false){
        //     console.log("没有值，注意！");
        // }
        return fResult;
    });

    // ↓ 涨跌状态，值为 1 是上涨 
    // ↓ 控制图表横线的颜色 
    const currentPriceStatus_L = computed(()=>{
        const aRData = chartState_r.data;
        const oBackup = {close: 0, open: 0, value: 0};
        const oLast = aRData.at(-1) || oBackup;
        const bIncreasing = (()=>{
            if (chartState_r.chartType === oChartConfig01_tt.area){
                return oLast.value > aRData.at(-2)?.value;
            }
            return oLast.close > oLast.open;
        })();
        return Number(bIncreasing);
    }); 

    const R = computed(()=> {
        return `At(r.selectedPair)`;
    });
    
    // ↓ 查验是否在特定币种 
    const isCorgiWaves_S = computed(() => {
        return chartState_r.selectedPair === oSpecialCoin?.pairName;
    });
    // ↓ 统计 0点标记 
    const fnMarkZeroClock_C = (aData) => {
        if (isCorgiWaves_S.value == false){
            return; // 非特定币种没有0点标记 
        }
        const t01 = Date.Now();
        let arr01 = [];
        aData.forEach(oCur => {
            if (oCur.time % iDaySeconds === 0){
                arr01.push(oCur.time);
            }
        });
        if (!arr01.length) return;
        const aSet01 = new Set([...arr01, ...chartState_r.chartMarkers]);
        const aZeroList = [...aSet01].sort(); 
        if (0 && import.meta.dev){
            const aTestList = aZeroList.forEach((cur, idx)=>{
                const sDate = new Date((cur as any) * 1_000).toLocaleString();
                return sDate;
            });
            console.log("0点列表：\n", aTestList); 
        }
        chartState_r.chartMarkers = aZeroList;
        console.log("0点标记统计耗时：", Date.Now() - t01);
    };
    // ↓ 切换币种，清空相关数据 
    const setSelectedPair_A = (selectedPair) => {
        const toSet = (
            selectedPair
            && chartState_r.selectedPair !== selectedPair
        );
        if (!toSet) return;
        chartState_r.data = [];
        chartState_r.chartMarkers = [];
        chartState_r.selectedPair = selectedPair; 
    }

    // ↓ 导出为 setSelectedTick: setSelectedTick_O 
    // ↓ 切换图表的数据粒度 
    const setSelectedTick_O = (iRangeValMs) => {
        const shouldItBeSet = (
            iRangeValMs &&
            iRangeValMs !== chartState_r.selectedTick // ←含义不明 
        );
        if (!shouldItBeSet) return;
        chartState_r.data = []; // 清空
        chartState_r.chartMarkers = [];
        chartState_r.selectedTick = iRangeValMs; // 重要查询对象 
        chartState_r.chartType = ( // 标记类型 
            iRangeValMs === oTickOptions_M.Tick
            ? oChartConfig01_tt.area
            : oChartConfig01_tt.candlestick
        );
    };

    // ↓ 保存大片 tick 数据（私有方法）
    // ↓ 查询大片 tick 之后调用此方法 
    const fnDataUpdater_x = (oDateRequested) => {
        // console.log("数据来了:", oDateRequested); 
        waveObj_l.value = void 0;
        oDateRequested.data ||= []; // 容错 
        // ↓ 先记录 marker，然后保存 data 
        fnMarkZeroClock_C(oDateRequested.data); 
        if (chartState_r.data.length){
            // console.log("将查询得到的数据添加到左侧：",  ); 
            // console.log(deepCopy(oDateRequested.data.at(-1))); 
            // console.log(deepCopy(chartState_r.data[0])); 
            const aNewArr = [
                ...oDateRequested.data, // ← 新值要插入到左侧 
                ...chartState_r.data,
            ];
            chartState_r.data = aNewArr;
        }else{
            chartState_r.data = []; // ←这一部动机不明，疑似有深意，有功效 
            chartState_r.data = oDateRequested.data;
        }
    }

    // ↓ 上锁，解锁 
    const switchHistoryLoading_U = (bValue) => {
        // console.log("数据查询锁：=>", bValue ? '上锁了' : '已经解锁--'); 
        chartState_r.historyLoading = !!bValue;
    }

    // ↓ 设定图表类型 
    const setCharType_c = (sTypeValue) => { 
        chartState_r.chartType = sTypeValue;
    }

    // ↓ 保存一条 tick 数据
    const saveOneTick_p = (oTick) => {
        if (!oTick) return;
        var oLast = chartState_r.data.at(-1); 
        // 标记0点，一定要在顶部先记录
        fnMarkZeroClock_C([oTick]);
        if (chartState_r.selectedTick === oTickOptions_M.Tick){
            waveObj_l.value = oTick;
            // ↓ 已经终止在此 💥 随后 smoothChart_e() 将处理相关操作 
            return;
        }
        // ↑ tick 模式
        // ↓ 其它--------------------------------- 
        waveObj_l.value = void 0; 
        if (oLast?.time < oTick?.time){
            chartState_r.data.push(oTick)
        }else{
            chartState_r.data[chartState_r.data.length - 1] = oTick;
        }
    }
    // ↓记录数据订阅状态，
    const setIsSubscribed_P = (bValue) => {
        chartState_r.isSubscribed = !!bValue;
    }

    // ↓ 用于高频更新： currentPairsPrices 对象 
    // ↓ 更新“所有币种” 的涨跌情况，高频调用 
    const setTickPairs_W = (oTickPairs) => {
        const aEntries = Object.entries(oTickPairs); 
        const oOldData = deepCopy(chartState_r.currentPairsPrices || {});
        // ↓ 开始遍历 
        const oFinalValue = aEntries.reduce((oResult, aKeyVal)=>{
            const [sPairsName, iPairsValue] = aKeyVal;
            const iOldValue = oOldData[sPairsName]?.value; 
            oResult[sPairsName] = {
                // ↓ 标记涨跌情况：1涨，0跌 
                status: iPairsValue > iOldValue ? 1 : 0,
                value: iPairsValue, 
            }
            return oResult;
        }, {});
        // console.log("chartState_r.currentPairsPrices\n", deepCopy(oFinalValue)); 
        // ↓ 打印对象有类似如下的多个键值对 
        // ADA_USDT : {status: 0, value: 0.40087061} 
        chartState_r.currentPairsPrices = oFinalValue;
    }

    // ↓ 清空 currentPairsPrices
    const clearCurrentPairsPrices_N = ()=>{
        chartState_r.currentPairsPrices = null; 
    }
    
    // ↓ 高频更新： stats24 
    // ↓ 在两类图表中都有按特定频率调用 
    const setStats24_y = (oStats24={})=>{
        Object.assign(
            chartState_r.stats24,
            oStats24,
        );
    }
    // ↓ 高频更新： fundingRate 
    const setRate_K = (fValue) => {
        chartState_r.fundingRate = fValue;
    }

    // ↓ 导出 
    // ↓ 清空关键数据
    const clearChartData_V = ()=>{
        chartState_r.data = [];
        chartState_r.chartMarkers = [];
    }

    // ↓ 查询某时段的图表数据 
    // public ◆ getPairHistory: Y 
    const getPairHistory_Y = async ({
        date = (chartState_r.data[0]?.time ?? void 0), 
        pair = chartState_r.selectedPair,
        rangeMs = oTickOptions_M.Tick, 
    }) => {
        if (chartState_r.historyLoading){
            return; // 已经上锁了， 
        }
        switchHistoryLoading_U(true); // 上锁 
        const oParams = {
            rangeMs,
            pair,
            date, 
        };
        // console.log("开始查询大片数据◆参数 ↓\n", deepCopy(oParams)); 
        let res = {} as ResTickData; 
        try{
            // 查询接口："futures.ticks" 
            res = await oWavesWs.EMIT_WAVES_FUTURES_TICK(oParams); 
        }catch(err){
            console.error("查询数据未成功:\n", err);
            return;
        }
        const hasError = !res || res.error;
        if (hasError || !res?.data?.[0]) {
            switchHistoryLoading_U(false);
            hasError && showNegativeNotify(res?.error);
            if (0 && import.meta.dev){ 
                console.log("查询大片数据◆未成功:\n", res); 
            }
            return;
        }
        if (0 && date && import.meta.dev){ 
            const oLast = res.data.at(-1);
            const iDate01 = date * 1_000;
            const iDate02 = oLast.time * 1_000;
            const iGap = iDate01 - iDate02; 
            console.log(
                '\nA-向接口传参时间值:', new Date(iDate01).toLocaleString(),
                '\nB-返回数据末尾时间:', new Date(iDate02).toLocaleString(),
                '\n时间间隔的正确性判断:', rangeMs == iGap ? '✅✅✅' : '❌❌❌❌❌❌', 
                '\n参数指定的时间间隔:', new Date(rangeMs).toISOString().slice(11, 19),
                '\n两者实际的时间间隔:', new Date(iGap).toISOString().slice(11, 19),
            );
        }
        fnDataUpdater_x({
            data: res.data,
            date,
        });
        0 && console.log("大片数据查询完毕 ↓\n", deepCopy(res.data));
        // ↓ 稍稍暂停，防止调用频率过高 
        await Sleep(100);
        switchHistoryLoading_U(false);
    };

    let callerID = 0;
    // ↓ 切换图表数据粒度时调用 
    // ↓ 订阅数据 
    const subscribeOnAggregatedPrices_D = () => { 
        if (chartState_r.isSubscribed) return; 
        // ↓ 先关旧的，提升稳定性 
        fnStoper();
        callerID++;
        const fn01 = (oData) => {
            if (!oData) return;
            saveOneTick_p(oData.tick);
            setTickPairs_W(oData.pairs); // 更新所有币种涨跌标记 
            setStats24_y(oData.stat24);
            setRate_K(oData.fundingRate); 
            setIsSubscribed_P(true);
            let fLast = 0;
            if (0 && import.meta.dev){
                const sTime = new Date(oData.tick.time * 1000).toLocaleString() && '';
                // const comVal = currentPriceByPair_F.value; // ←不能取这个，因为在波形图中此值不是接口值 
                const fVal = oData.tick.value || oData.tick.close; 
                const sVal = fVal.toFixed(3);
                const sMark = fLast == fVal ? 'Same to last!' : ''; 
                console.log(`callerID:${callerID} => ${sTime} ☢️`, sVal, sMark); 
                fLast = fVal;
            }
        };
        console.log("开始订阅图表波动数据：📈", ); 
        const fnReturnedStoper = oWavesWs.ON_WAVES_TICK(fn01); 
        fnStoper = () => { 
            console.log(`已经关闭：callerID:${callerID}`); 
            fnReturnedStoper(); 
        }
    }

    // ↓ 停止接收数据 
    const unsubscribeOnAggregatedPrices_I = ()=>{
        fnStoper();
        setIsSubscribed_P(false);
    }

    // ↓ 退场的方法  
    // ↓ 执行相关取消与清空 
    const leaveRoom_ = () => { 
        clearCurrentPairsPrices_N();
        unsubscribeOnAggregatedPrices_I(); 
        clearChartData_V();
        // ↓ 报告后台停止推送实时数据，
        oWavesWs.EMIT_WAVES_LEAVE({
            room: 'publicPositionsRoom',
        });
        waveObj_l.value = void 0;
        hasLeftTheRoom = true; 
    };

    // ↓ 递归调用，仅在 tick 模式会真正有效执行  
    // ↓ 导出为: smoothChart: smoothChart_e,
    const smoothChart_e = (
        // ↓ 原版默认频率 20 次 / 秒 
        iDelay = Math.round(1_000 / 20), 
    )=>{
        // ↓ 终止递归 
        if (hasLeftTheRoom) return; 
        const aData = chartState_r.data; 
        const oLast = aData.at(-1); 
        aData.length || (waveObj_l.value = void 0);
        if (
            waveObj_l.value?.value // ← 只有 tick 模式能通过此判断 
            && aData.length
            && oLast?.value
        ) {
            const aa = (waveObj_l.value.value ?? oLast.value) - oLast.value;
            const bb = oTickOptions_M.Tick / iDelay; 
            const oNewLast = {
                time: waveObj_l.value?.time,
                value: oLast.value + (aa / bb),
            };
            if (oNewLast.time === oLast.time){
                aData[aData.length - 1] = oNewLast; 
            }else if (oNewLast.time > oLast.time){
                aData.push(oNewLast);
            }
        }
        // ↓ 无限递归 
        setTimeout(() => {
            smoothChart_e(iDelay)
        }, iDelay);
    };

    return {
        chartState: chartState_r,
        currentPriceStatus: currentPriceStatus_L, // 当前币种的：涨跌标记，返回 1/0 表示跌涨 
        currentPriceByPair: currentPriceByPair_F, // 当前币种的：最新点数，最右侧的点数 
        // correspondingCurrency: R, 
        isCorgiWaves: isCorgiWaves_S, // 特殊币种布尔型标记 
        // --- ↑ 数据 ------------------------------------- 
        // --- ↓ 方法 ------------------------------------- 
        smoothChart: smoothChart_e, // 启动无限递归 
        setSelectedPair: setSelectedPair_A, 
        setSelectedTick: setSelectedTick_O, 
        // --- ↓ 图表数据的查询，数据流处理，与关停 ------------------------ 
        leaveRoom: leaveRoom_, // 退场 
        getPairHistory: getPairHistory_Y, // 查询历史数据 
        subscribeOnAggregatedPrices: subscribeOnAggregatedPrices_D, // 开始订阅 
        unsubscribeOnAggregatedPrices: unsubscribeOnAggregatedPrices_I, // 取消订阅 
        // --- ↑ 通信相关方法 -------------------------------- 
        // --- ↓ 其它 --------------------------------- 
        setCharType: setCharType_c,
        clearChartData: clearChartData_V,
        setIsSubscribed: setIsSubscribed_P, 
    };
}

// ==================================================================== 
// ==========  ↑ 实时图表数据 ================================================ 
// ==========  ↓ 游戏配置信息相关 ================================================ 
// ==================================================================== 


export const settingsState_f = reactive({ 
    // ↓ 暂未启用，是特殊币 
    // seedsInfo: { currentRoundHash: "", randomSeeds: [] }, 
    // ↓ 控制手动平仓时要不要弹出确认窗口
    // ↓ 在平仓操作时，如果用户勾选了‘不再弹出此窗口’，那么此值也将被修改为 false 
    userSettings: { 
        confirmCashOut: true,
        confirmAllCashOut: true, // 同上  
    },
    // ↓ 图表时间粒度（rangeMs）这里默认为 tick；而且在未登录时查询得到的也是 tick 
    currentPeriod: oTickOptions_M.Tick,
    // ↓ 各币种配置信息，是一个【巨大的对象】，在查询后赋值到此，原版默认值是 null 
    pairsSettings: null as AllPairsConfig, 
    // ↓ 同上，是【巨大对象】数组形态（按 weight 值升序）  
    futuresPairs: [], 
    readTAC: false, // 欢迎窗口是否已读的标记  
    settingsReady: false,
});

// ↓ 这是“倒计时” 监听通道的关闭器 
let fnToStopTimeChanel = () => null; 

export const fnSettingCenter_Ft = () => { 
    const oWavesWs = useWavesSocket();
    const oUserStore = useUserStore(); 

    // -- ↓ 当前币种设定信息 ----------------------------------------------  
    // 最终导出： currentPairSettings: currentPairSettings_S
    const currentPairSettings_S = computed(() => {
        const sSelectedPair = chartState_r.selectedPair;
        const oPairsSettings = settingsState_f.pairsSettings || {}; 
        const oResult = oPairsSettings[sSelectedPair];
        return oResult; 
    }); 

    // ↓ 当前虚拟币对应的“下注币种” 的相关配置信息 
    const curPairSettingsAndCurrency = computed(()=>{
        const oCurPairSettings = currentPairSettings_S.value;
        // ↓ 当前币种 
        const currencyName = oUserStore.oNowCurrency.currencyName;
        // ↓ 当前币种的设定
        const oCrrencySetting = oCurPairSettings?.availableCurrencies?.[currencyName] || {};
        const oResult = {
            currencyName, // 便捷标记，很实用！
            ...oCrrencySetting,
        }
        return oResult;
    });

    // currentPairCoeffValues: C 
    // 取得：当前币种 && 当前涨跌类型 => 对应的 coeff 配置对象 
    // 此值将来做为 coeffRates 值参与运算，此值将被传入到某个方法，方法返回一个浮点值 
    const currentPairCoeffValues_C = computed(() => { 
        const oCurrentPairSettings = currentPairSettings_S.value || {};  
        const sKey = `${oWavesBetForm_a.feeType}Fee`;
        const result = oCurrentPairSettings[sKey];
        return result; 
    });

    const currentPairPrecision_A = computed(()=>{
        const result01 = (
            currentPairSettings_S.value?.precision
            || 2
        );
        return result01;
    });

    // ↓ 查询“虚拟币” 的小数点位数（股价的小数小数位数） 
    const fnGetDecimalsByCurrency_O = (sPair)=>{
        const oSetting = settingsState_f.pairsSettings?.[sPair];
        const {precision = 2} = oSetting || {}; 
        return precision; 
    }
    // ↓ 查询“下注币种金额” 的最大小数位数 
    const fnGetTheiDecimalPlaces = (
        sPair, // 虚拟币名称 
        currencyName='', // 下注币种名称 
    )=>{
        const oSetting = settingsState_f.pairsSettings?.[sPair];
        if (!oSetting) return 2;
        // ↓ 默认当前界面币种 
        currencyName ||= oUserStore.oNowCurrency.currencyName;
        // oSetting.availableCurrencies  
        const oTarget = oSetting?.availableCurrencies?.[currencyName];
        const iResult = oTarget?.iDecimalPlaces || 2;
        return iResult; 
    }

    // ↓ 去标记“经查询完毕游戏配置” 了
    const markSettingsReady_x = ()=>{
        settingsState_f.settingsReady = true; 
    }
    // ↓ 保存查询到的【各币种】配置信息 
    // ↓ 01用于首页查询赋值，02用于后期接收的动态值的注入 
    const fnSetPairsSettings_U = (
        oPairs:AllPairsConfig, // 多币种配置信息 
    ) => { 
        if (!settingsState_f.pairsSettings){ 
            settingsState_f.pairsSettings = oPairs; 
            return;
        }
        Object.keys(oPairs).forEach(sOnePair => {
            const oTheOld = settingsState_f.pairsSettings[sOnePair];
            const oNewItem = {
                ...oTheOld, 
                ...oPairs[sOnePair], // 新顶旧 
            };
            settingsState_f.pairsSettings[sOnePair] = oNewItem; 
        });
    }

    // ↓ 保存查询到数据到本地 futuresPairs 
    const setFuturesPairs_W = (
        oPairs:AllPairsConfig, // 多币种配置信息 
    ) => { 
        const aData = (()=>{
            const aStep01 = Object.entries(oPairs);
            aStep01.sort((v01, v02)=>{
                const aa = v01[1].weight;
                const bb = v02[1].weight;
                const result = aa - bb; // 升序 
                return result;
            });
            const aFinalArr = aStep01.reduce((aResult, aCur) => {
                return [
                    ...aResult,
                    aCur[0],
                ]; 
            }, []);
            return aFinalArr;
        })(); 
        settingsState_f.futuresPairs = aData; 
    }
    // ↓ 初步看：更新某个【单币种】配置信息 
    // ↓ 入参是接口返回值 
    const updateCurrentPairSettings_c = (oRes) => {
        if (!oRes) return;
        const sPair = chartState_r.selectedPair; 
        const oPairsSettings = settingsState_f.pairsSettings; 
        if (!oPairsSettings || !oPairsSettings[sPair]){
            return; 
        }
        Object.keys(oRes).forEach((sKey) => {
            if (Reflect.has(oPairsSettings[sPair], sKey)) {
                oPairsSettings[sPair][sKey] = oRes[sKey];
            }
        });
    }
    // ↓ 将服务器返回的配置信息赋值 
    // ↓ 也用于日常修改值 
    const fnUpdateUserSettings_p = (vUserSettings) => {
        console.log("用户 confirm 偏好：", vUserSettings); 
        if (typeof vUserSettings == "string"){
            // ↓ 取反 
            const newOne = !settingsState_f.userSettings[vUserSettings];
            settingsState_f.userSettings[vUserSettings] = newOne;
        } else {
            for (const sKey in vUserSettings) {
                settingsState_f.userSettings[sKey] = vUserSettings[sKey]; 
            }
        }
    }

    // ↓ 保存查询到的 RangeMs 
    const fnSetRangeMs_P = (iRangeMs) => {
        settingsState_f.currentPeriod = iRangeMs; 
    }

    // ↓ ❌ 保存查到的 randomSeeds （当前版本中不需要）
    // const saveSeedsInfo_N = (oData) => {
    //     Object.assign(settingsState_f.seedsInfo, {
    //         randomSeeds: oData.seeds,
    //         currentRoundHash: oData.currentRoundHash,
    //     });
    // }

    // ↓ public 
    // ↓ 记录已读状态
    const fnSetReadTAC_y = (bValue) => {
        settingsState_f.readTAC = bValue;
    };
    
    // ↓ 查询配置信息（巨大对象） 
    const getSettings = async () => {
        const oRes = await oWavesWs.EMIT_GET_WAVES_SETTINGS(); 
        if (!oRes || oRes.error) {
            showNegativeNotify(oRes?.error);
            return;
        }
        for (const [sPair, oPairSettings] of Object.entries(oRes.pairs)){
            const aCurrency = Object.entries(oPairSettings.availableCurrencies);
            for (const [sCurrency, oCurSetting] of aCurrency){
                const sMin = String(oCurSetting['minWagerAmount'] || 0);
                const {length} = sMin.split('.')[1] || ''; 
                // ↓ 补充一个键 🔶 表示这个下注的币种的下注金额小数倍数，很重要 
                oCurSetting['iDecimalPlaces'] = Math.max(2, length);
            }
        }
        if (1 && import.meta.dev){
            console.log("Waves 游戏配置：\n", deepCopy(oRes)); 
        }
        // ↓ 保存各币种配置信息 
        fnSetPairsSettings_U(oRes.pairs);
        setFuturesPairs_W(oRes.pairs);
        // ↓ 专门处理 oST 赋值 
        const oST = oRes.commonUserSettings; 
        fnUpdateUserSettings_p(oST.settings);
        fnSetRangeMs_P(oST.rangeMs);
        fnSetReadTAC_y(oST.termsAndConditionsConfirmed ?? false); 
        const {hasLogged} = await getUserInfo();
        if (hasLogged){ 
            // ↓ 仅在登录后执行，暂时不明所以 
            markSettingsReady_x(); 
        }
    };

    return {
        settingsState: settingsState_f, 
        currentPairSettings: currentPairSettings_S, 
        curPairSettingsAndCurrency, // 
        currentPairCoeffValues: currentPairCoeffValues_C, 
        currentPairPrecision: currentPairPrecision_A, 
        setReadTAC: fnSetReadTAC_y, 
        updateUserSettings: fnUpdateUserSettings_p, 
        updateCurrentPairSettings: updateCurrentPairSettings_c, 
        getDecimalsByCurrency: fnGetDecimalsByCurrency_O, 
        fnGetTheiDecimalPlaces,
        // ---- ↑ ----------------------------- 
        getSettings,
        // ↓ 没有数据就查询，有数据就直接返回 
        async fetchSettingsIfNeed(){
            if (settingsState_f.pairsSettings){
                return true;
            }
            const oRes = await getSettings();
            return oRes; 
        },
        // ----- ↓ 待分析 ---------------------------------------
        // ↓ 记录用户“已读” 操作 
        updateReadTAC: async () => { 
            const res = await oWavesWs['xxx']({
                termsAndConditionsConfirmed: settingsState_f.readTAC, 
            });
        },
        // ↓ ❌ 当前版本不需要查询 randomSeeds  
        // getRandomSeeds: ()=>{ 
        //     if (!l) return;
        //     const fnCallback = oRes=>{
        //         if (oRes.Err) {
        //             return d({
        //                 type: "error",
        //                 title: n.t("common.Error"),
        //                 text: n.t(v(oRes))
        //             });
        //         }
        //         if (!oRes.data) return; 
        //         saveSeedsInfo_N(oRes.data);
        //     };
        //     l.emit(
        //         "futures.seeds",
        //         {},
        //         fnCallback,
        //     ); 
        // },

        // ↓ 记录用户设定到服务器 
        // ↓ 记录用户关于 “是否要弹出确认窗口” 的偏好 
        // 4233["futures.updateSettings", {"confirmCashOut":true,"confirmAllCashOut":true}]	
        setUserSettings: async ()=>{
            const res = await oWavesWs.EMIT_WAVES_UPDATE_SETTINGS({
                // ↓ 参数示例：{"confirmCashOut": true, "confirmAllCashOut": true} 
                ...settingsState_f.userSettings, 
            });
            if (!res) return;
            if (import.meta.dev){
                console.log("已经保存用户 confirm 偏好成功");
            }
        },
        // ↓ 以下2个方法用于 futuresSettingsUpdate 的订阅和取消，有接收倒计时信息 
        // ◆此处上下2行“接口名称” 高度相似    
        subscribeOnFuturesSettingsUpdate: ()=>{
            const fnCallback = res=>{
                if (res.error){
                    showNegativeNotify(res?.error);
                    return;
                }
                if (!res.data) return;
                const oNewPairSetting = res.data.pairs;
                if (1 && import.meta.dev){
                    const oNewTime = Object.values(oNewPairSetting)[0];
                    oNewTime['endOfFundingPeriod'] += Math.random(); // 稍改一下，以便触发 watch 
                    oNewPairSetting[Object.keys(oNewPairSetting)[0]] = oNewTime; 
                    console.log("收到最新时间信息 🛡️：", deepCopy(oNewPairSetting)); 
                }
                fnSetPairsSettings_U(oNewPairSetting);
            };
            fnToStopTimeChanel();
            const fn2Stop = oWavesWs.ON_WAVES_SETTINGS_UPDATE(
                fnCallback,
            );
            fnToStopTimeChanel = ()=>{
                console.log('取消订阅倒计时信息：');
                fn2Stop();
            }
        },
        // ↓ 取消订阅（暂未调用）
        unsubscribeOnFuturesSettingsUpdate: () => {
            socket.off("futuresSettingsUpdate"); 
        },
    }; 
}

// ==================================================================== 
// ========== ↑ 游戏设置信息 ⚓ ========================================
// ========== ↓ 大表格相关（建仓平仓方法都在其内）========================= 
// ==================================================================== 

// ↓ 大表格重要数据 
// ↓ 发起平仓请求的方法，等 
export const oPositionData_i = reactive({ 
    totals: 0,
    positions: [], // 查询结果的行数据  
    tableLines: [], 
    pagination: { page: 1, perPage: 10 },
    // --- ↓ 移动端的 active 专用，↑ 所有其它情况 --------------------------------  
    mobTotals: 0,
    mobPositions: [], // 查询结果的行数据  
    mobTableLines: [], 
    mobPagination: { page: 1, perPage: 4 },
    // -- ↑ 表格数据相关，桌面与移动端有不同的分页设定 ---------------------- 
    // -- ↓ 其它 --------------------------------------------------------- 
    currentTab: HistoryTabsEnum.active as HistoryTabsEnum, // 大表格的当前页 
    selectedInstrument: "" as ('' | oPairsMap), // 目标币种对（用于查询表格数据的参数） 
    beforeRemovalInfo: null, // 多个记录合约的最新状态值 
    lastPublicUpdated: null, // 1条最新收到的历史记录 object 型数据  
    oStates: {}, // 保存接收到的非 active 的合约状态; 示例：{[id]: '最新状态', ...} 
    // -- ↓ 多个布尔值 ------------------------------------------------------------ 
    beforeRemovalLoading: false, 
    isNewCreated: false, // 建仓之后修此值为真  
    loading: false, 
    closingAll: false, // 记录是否正在平仓所有项 
}); 

// ↓ 这是“合同最新状态” 监听通道的关闭器 
let fnToStopFuturesUpdate = () => null; 

// 头寸管理中心：
// 建仓，平仓，查询，修改等，
export const oPositionCenter_yt = () => {
    const {t: $tFn} = useNuxtApp().$i18n; 
    const {theme} = useRuntimeConfig().public.tailwind;
    const {max} = theme.extend.screensInt.sm;
    const oWavesWs = useWavesSocket();
    const oGlobalStore = useGlobalStore(); 
    const { updateCurrentPairSettings } = fnSettingCenter_Ft(); 
    const iExtraMobPerPage_C = 5; // 常量 
    const timer_A = ref(null); // 定时器保存（此处多余使用 ref 数据) 
    // const {selectedPair: _} = toRefs(chartState_r); // == chartState_r.selectedPair 
    
    // ======= ↑ 声明一些常量 =========================================== 
    // ======= ↓ 计算值 ================================================= 

    // ↓ 移动端标记，单纯评估屏幕， 
    const isMobile_S = computed(() => {
        // 原版 640 ，这时里调用变量：574 
        return oGlobalStore.innerWidth < max; 
    }); 

    // ↓ 每页行数量 
    const perMobPage_O = computed(() => { 
        const iResult = (
            oPositionData_i.mobTotals === iExtraMobPerPage_C
            ? iExtraMobPerPage_C
            : oPositionData_i.mobPagination.perPage
        ); 
        return iResult;
    }); 

    // ======= ↑ 数据 ============================================== 
    // ======= ↓ 方法 ============================================== 

    // ↓ private 
    // ↓ 保存表格行数据 💥 
    const setPositions_e = (oData) => { 
        if (oData.mob){
            oPositionData_i.mobPositions = oData.bets; 
        }else{
            oPositionData_i.positions = oData.bets; 
        }
    }
    // ↓ public 
    // ↓ 页码修改（桌面端）  
    const setPagination_t = (oData) => {
        oPositionData_i.pagination = {
            ...oPositionData_i.pagination, 
            ...oData,
        };
    }
    // ↓ public 
    // ↓ 页面修改（移动端） 
    const setMobPagination_o = (oData) => { 
        oPositionData_i.mobPagination = {
            ...oPositionData_i.mobPagination, 
            ...oData,
        };
    }
    // public
    // ↓ 导出之前没有内部调用（在目前，导出后也没调用） 
    // ↓ 保存数据到... 
    const setTableLines_m = (oData) => {
        // 入参说明： {mob, isPublic, tableLines=[]} = oData 
        const {perPage=10} = oPositionData_i.pagination || {}; 
        const isPublic = (
            oPositionData_i.currentTab === HistoryTabsEnum.public 
            || oData.isPublic 
        );
        const fnForPublic = () => { 
            const aTableLines = oPositionData_i.tableLines || [];
            // ↓ 
            if (oData.tableLines.length > 1){
                oPositionData_i.tableLines = oData.tableLines; 
            }else{
                aTableLines.unshift(...oData.tableLines);
                // ↓ 防止超长，减去尾部   
                if (aTableLines['length'] > perPage ){
                    aTableLines.splice(perPage, 1/0); 
                }
            }
        };
        // ------------------ 
        if (oData.mob){
            oPositionData_i.mobTableLines = oData.tableLines; 
        }else if(isPublic){
            fnForPublic();
        }else{
            oPositionData_i.tableLines = oData.tableLines; 
        }
    }
    // ↓ public 
    // ↓ 切换表格页签
    const setCurrentTab_b = (sNewTab) => {
        oPositionData_i.currentTab = sNewTab;
    }
    // ↓ private 
    // ↓ 记录数据总行数，在 public, leaderboard 下此数据无意义 
    const setTotal_h = (obj) => { 
        obj.mob
        ? oPositionData_i.mobTotals = obj.count
        : oPositionData_i.totals = obj.count
    }
    // ↓ private
    // ↓ 保存 1 条历史记录 
    const fnSaveLastPublicPosition_j = (oRes) => {
        oPositionData_i.lastPublicUpdated = oRes;
        // ↑ 原版，↓ 追加
        const isPublicTab = (
            oPositionData_i.currentTab === HistoryTabsEnum.public
        );
        if (!isPublicTab) return; 
        console.log("追加 Public 页数据：", deepCopy(oRes)); 
        const {perPage=10} = oPositionData_i.pagination; 
        oPositionData_i.positions.unshift(oRes); 
        // ↓ 防止超长，减去尾部
        if (oPositionData_i.positions.length > perPage ){
            oPositionData_i.positions.splice(perPage, 1/0); 
        }
    }

    // ↓ private 
    // ↓ 接收接口值，用于更新 beforeRemovalInfo 
    // ↓ 合约状态变为非 active 之后都会调用此方法 
    const fnAppendOneFuturesUpdate_Q = (oRes) => {
        if (!oRes.id) return;
        const {id, ...oOthers} = oRes;
        const oNewData = {
            ...oPositionData_i.beforeRemovalInfo, 
            [id]: {
                ...oOthers,
            },
        };
        oPositionData_i.beforeRemovalInfo = oNewData; 
    }
    // ↓ public 
    // ↓ 修改币种， 
    const setSelectedInstrument_w = (sValue) => {
        oPositionData_i.selectedInstrument = sValue; 
    }

    // ↓设定 Loading 状态，在表格数据查询完毕后调用 
    const setLoading_q = (bValue)=>{
        oPositionData_i.loading = bValue;
    }
    // ↓ 建仓成功之后调用 
    const setIsNewCreated_st = (bValue)=>{ 
        oPositionData_i.isNewCreated = bValue; 
    }

    // ↓ 查询大表数据之后调用 
    const doClean = ()=>{
        oPositionData_i.beforeRemovalInfo = null; 
    }

    // ↓ public
    // ↓ 表示行数据清空，在查到了新数据时有调用用于清除旧数据 
    const clearPositions_rt = (
        isMobile= false,
    )=>{
        if (isMobile){
            oPositionData_i.mobPositions = []; 
            oPositionData_i.mobTableLines = []; 
        }else{
            oPositionData_i.positions = []; 
            oPositionData_i.tableLines = []; 
        }
    }
    // ↓ public
    // ↓ 清空行数量信息  
    const clearTotalPositions_lt = (isMobile= false)=>{
        isMobile
        ? oPositionData_i.mobTotals = 0
        : oPositionData_i.totals = 0
    }
    // ↓ 页码数值复位 
    const resetPagination_ft = (isMobile=false) => {
        isMobile
        ? oPositionData_i.mobPagination = {
            page: 1, 
            perPage: 4, 
        }
        : oPositionData_i.pagination = {
            page: 1,
            perPage: 10, 
        }
    }
    // public 
    // ↓ 查询大表格数据，此方法有被包装为延时方法 
    const getPositions_z = async ({
        tabType, // 4种表的类型 
        forMobile = false,
        clean = false,
    }) => {
        // console.log('开始查询大表格数据：', tabType); 
        const isDev = import.meta.dev;
        const oPagination = (
            forMobile
            ? oPositionData_i.mobPagination 
            : oPositionData_i.pagination 
        ); 
        const perPage = ( // 每页行数 
            (!forMobile && oPositionData_i.currentTab == HistoryTabsEnum.leaderboard) 
            ? 10 // 排行榜固定显示前 10 行 
            : oPagination.perPage 
        );
        const oParams = {
            type: tabType,
            perPage,
            page: oPagination.page,
            pair: oPositionData_i.selectedInstrument, 
        };
        const oRes = await oWavesWs.EMIT_WAVES_POSITION_HISTORY(oParams); 
        const unmatched = (
            tabType != oPositionData_i.currentTab
            && !forMobile
        );
        if (unmatched) {
            isDev && console.log("当前数据与当前页不匹配，跳过 📕"); 
            isDev && console.log("requested, and received ↓\n", deepCopy(oPagination), deepCopy(oRes));  
        } else {
            // 执行至此，表示数据匹配，清空旧的行数据 
            clearPositions_rt(forMobile);
        }
        if (!oRes || oRes?.error || !oRes.data || unmatched){
            setLoading_q(false); 
            oRes?.error && showNegativeNotify(oRes?.error);
            return; 
        }
        const {count = 0, items=[]} = oRes.data; 
        const loadPreviousPage = ( 
            count > 0
            && !items?.length 
            && oPagination.page > 1
            && tabType === oTable4Types.active 
        );
        if (loadPreviousPage){
            oPagination.page--; 
            if(1 && isDev){ 
                console.log(`退至第 ${oPagination.page} 页重载 ♾️♾️`); 
            }
            // ↓ 递归调用查询，查前一页
            return getPositions_z({
                tabType,
                forMobile,
                clean,
            });
        }
        console.log(`大表格数据 ${tabType} ↓\n`, deepCopy(items)); 
        if (0 && isDev && tabType !== oTable4Types.active){
            items.forEach((oCurHistory, idx) => {
                const {fGap, fGapRate, myPnl} = fnPnlChecker(oCurHistory);
                // if (fGap < 0.1) return;
                var sMark = fGapRate < 0.1 ? '✅' : '❌❌❌';
                console.groupCollapsed(`PNL校验-${idx}：${sMark} (${oCurHistory.state}) 💠 ID: ${oCurHistory._id}`); 
                console.log('fGapRate = ', fGapRate.toFixed(6), '%'); 
                console.log('公式值', myPnl);
                console.log('接口返回值', oCurHistory.pnl);
                console.groupEnd();
            });
        }
        setPositions_e({
            mob: forMobile,
            bets: items, 
        });
        setTotal_h({
            mob: forMobile, 
            count, 
        });
        setLoading_q(false);
        clean && doClean();
        return oRes;
    }
    
    // ↓ public 
    // ↓ 建仓fn 
    const createPosition_dt = async (oParams) => { 
        const type = oParams.type;
        // ↓ 后补：类型不明，应当终止， 
        if (!type) return;
        const isDev = import.meta.dev;
        const trigerProfit = (
            Number(oWavesBetForm_a.takeProfit) > 0
            || Number(oWavesBetForm_a.takeProfitAmount) > 0
        );
        if (!trigerProfit && oWavesBetForm_a.selectedTriggerProfit) { 
            isDev && console.log("清除触发标记1");
            oWavesBetForm_a.selectedTriggerProfit = oTriggerType.none;
        }
        const trigerLoss = (
            Number(oWavesBetForm_a.stopLoss) > 0
            || Number(oWavesBetForm_a.stopLossAmount) > 0 
        );
        if (!trigerLoss && oWavesBetForm_a.selectedTriggerLoss){ 
            isDev && console.log("清除触发标记2");
            oWavesBetForm_a.selectedTriggerLoss = oTriggerType.none;
        }
        const oForm = {
            type, 
            wager: oWavesBetForm_a.wager,
            multi: oWavesBetForm_a.multi,
            feeType: oWavesBetForm_a.feeType,
            pair: chartState_r.selectedPair as any, 
            // -- ↓ 止盈止损 --------------------------------- 
            selectedTriggerLoss: oWavesBetForm_a.selectedTriggerLoss,
            selectedTriggerProfit: oWavesBetForm_a.selectedTriggerProfit, 
            takeProfitPrice: String(oWavesBetForm_a.takeProfit),
            takeProfitAmount: String(oWavesBetForm_a.takeProfitAmount),
            stopLossPrice: String(oWavesBetForm_a.stopLoss),
            stopLossAmount: String(oWavesBetForm_a.stopLossAmount),
        };
        const amountMemory = useAmountMemoryStore();
        amountMemory.setLastAmount(oForm.wager);
        paramsChecker(oForm);
        if (oForm.stopLossPrice !== '' && oForm.takeProfitPrice !== '') {
            if (type === oLongShort.long && Number(oForm.takeProfitPrice) < Number(oForm.stopLossPrice)) {
                return showNegativeNotify({
                    i18n: 'waves.futures.errors.profitPrice1',
                    position: 'top', // 在顶部弹出，防止侵入用户操作
                    type: 'warning',
                    timeout: 1.5 * 1_000, // 驻留时长 ms
                    actions: [],
                });
            }
            if (type === oLongShort.short && Number(oForm.takeProfitPrice) > Number(oForm.stopLossPrice)) {
                return showNegativeNotify({
                    i18n: 'waves.futures.errors.lossPrice1',
                    position: 'top', // 在顶部弹出，防止侵入用户操作
                    type: 'warning',
                    timeout: 1.5 * 1_000, // 驻留时长 ms
                    actions: [],
                });
            }
        }
        const res = await oWavesWs.EMIT_WAVES_POSITION_CREATE(oForm); 
        if (!res || res.error) {
            console.log("建仓异常：", deepCopy(oForm)); 
            showNegativeNotify(res?.error); 
            return; 
        }
        console.log("建仓成功了↓\n", deepCopy(oForm)); 
        showNegativeNotify({
            i18n: 'waves.created',
            type: 'positive',
            position: 'top',
            timeout: 3_000, 
            // classes: 'waves-game-alert_mark_f5u8o6h5fd9cf', 
        });
        setIsNewCreated_st(true);
        // ↓ 实测，创建后要跳到 active 页，同时查询其最新数据 
        // ↓ 追加说明，今日发现创建后，后端会发一个信号到浏览器并由 futuresUpdate_dataUser() 接收，接收后会触发表格更新 —— 2025.02.11 19:25:21 星期二
        // loadActiveRows(); 
    }

    // ↓ 后补的加载数据的方法 
    const loadActiveRows = ()=>{
        if (oElementVisible.value.showTopActiveTable){
            oPositionData_i.mobPagination.page = 1; 
            getPositions_z({
                tabType: HistoryTabsEnum.active, 
                forMobile: true,
            });
        }else if(oPositionData_i.currentTab == HistoryTabsEnum.active){
            oPositionData_i.pagination.page = 1; 
            getPositions_z({
                tabType: HistoryTabsEnum.active, 
            });
        }else{
            // 跳转，会触发查询
            setCurrentTab_b(HistoryTabsEnum.active);
        }
    }

    // ↓ 无实际功能，仅调试 
    const paramsChecker = (oForm) => {
        if (!import.meta.dev && 0){
            return;
        }
        const stopWin = (
            (oForm.takeProfitPrice || oForm.takeProfitAmount)
            && !oForm.selectedTriggerProfit
        ); 
        const stopLoss = (
            (oForm.stopLossPrice || oForm.stopLossAmount)
            && !oForm.selectedTriggerLoss
        ); 
        if (stopWin){
            console.error('参数有误 stopWin', deepCopy(oForm));
        }
        if (stopLoss){
            console.error('参数有误 stopLoss',  deepCopy(oForm));
        }
    };
    // ↓ public  
    // ↓ 建仓后修改  
    const updatePosition_gt = async (oParams) => {
        const oData = {
            takeProfitPrice: oWavesBetForm_a.takeProfitUpdate + '',
            takeProfitAmount: oWavesBetForm_a.takeProfitAmountUpdate + '',
            stopLossPrice: oWavesBetForm_a.stopLossUpdate + '',
            stopLossAmount: oWavesBetForm_a.stopLossAmountUpdate + '',
            // ↑数值 ↓其它  
            positionId: oParams.positionId, 
            selectedTriggerLoss: oWavesBetForm_a.selectedTriggerLossUpdate,
            selectedTriggerProfit: oWavesBetForm_a.selectedTriggerProfitUpdate, 
        };
        console.log("修改开始：", oData); 
        const res = await oWavesWs.EMIT_WAVES_POSITION_UPDATE(oData); 
        if (import.meta.dev){
            console.log("修改完成：", res); 
        }
        if (!res || res['error']){
            showNegativeNotify(res?.['error']);
            return; 
        }
        // 修改后刷新表格的工作在 futuresUpdate_dataUser() 内执行 
        return res;
    },
    // ↓ 手动平仓 1 项 
    // 导出： closePositionById 
    closePositionById_mt = async (oParams) => {
        // ↓ 切换为平仓进行中的状态 
        fnAppendOneFuturesUpdate_Q({
            id: oParams.positionId,
            state: WavesContractStateAll.cashOutProcessing,
        }); 
        const res = await oWavesWs.EMIT_WAVES_POSITION_CLOSE_ONE({
            positionId: oParams.positionId,
        });
        if (!res || res['error']) return;
        if (import.meta.dev){
            console.log("已经平仓了 1 项", oParams); 
        }
    }

    // ↓ 手动平仓 All 
    // 导出： closeAllPositions 
    const closeAllPositions_Pt = async ()=>{
        const aClosable = [
            ...oPositionData_i.positions,
            ...oPositionData_i.mobPositions,
        ].filter(cur => {
            if (cur.state != WavesContractStateAll.active)
                return;
            const state = oPositionData_i.oStates[cur._id]?.state; 
            if (state && state != WavesContractStateAll.active){
                return;
            }
            fnAppendOneFuturesUpdate_Q({
                id: cur._id,
                state: WavesContractStateAll.cashOutProcessing, 
            }); 
            return true;
        });
        if (!aClosable.length) {
            return console.log("平仓所有项操作被放弃"); 
        }
        oPositionData_i.closingAll = true;
        const res = await oWavesWs.EMIT_WAVES_POSITION_CLOSE_ALL();
        Sleep(2_000).then(()=>{
            oPositionData_i.closingAll = false;
        });
        if (!res || res['error']) return; 
        if (import.meta.dev){
            console.log("已经平仓了所有项", res); 
        }
    }
    
    // ========================================================
    // ↓ private 方法 
    // ↓ 这里第 2 个参数是“延时” 的毫秒数 
    // ↓ 最初2行目前看仅用于查询 “active” 页的数据 
    // ========================================================
    const oTabDataGetterSlow = fnDelayPackageMaker(getPositions_z, 500); 
    const oTabDataGetterFast = fnDelayPackageMaker(getPositions_z, 100); 
    const fnUpdateTabClosed = fnDelayFnMaker(getPositions_z, 100); 
    // ↓ public 
    // ↓ 取消订阅 futuresUpdate 
    const unSubscribeOnFuturesPositions_Tt = () => {
        // socket.off("futuresUpdate"); 
        fnToStopFuturesUpdate();
    }

    // ↓ public 
    // ↓ 监听 futuresUpdate 
    // ↓ 接收某个合约的最新状态，如平仓进行中 
    const futuresUpdate_receiver = ()=>{
        fnToStopFuturesUpdate?.();
        const fn4close = oWavesWs.ON_WAVES_CONTRACT_UPDATED((oRes) => {
            if (!oRes || oRes.error){
                showNegativeNotify(oRes?.error);
                return;
            }
            const todo = oRes?.data?.state; 
            if (!todo) return;
            futuresUpdate_dataUser(oRes); 
        }); 
        const sChannel = `接收合约最新状态的通道 ${new Date().toLocaleString()} --`;
        console.log(`${sChannel} started ✅`); 
        fnToStopFuturesUpdate = ()=>{
            console.log(`${sChannel} closed 💥`); 
            fn4close();
        };
        return fnToStopFuturesUpdate;
    }

    // private 
    // ↓ 接收某个合约“最新状态”后使用执行重载  
    const futuresUpdate_dataUser = async (oRes) => { 
        const { 
            id,
            state, // 可能的值有： cashOutProcessing, cashed, active(修改仓), 
            maxUserPositionAmount, 
        } = oRes.data; 
        if (1 && import.meta.dev){ 
            // ↓ 具体状态值请参考：WavesContractStateAll 
            console.log("合约最新状态：🈴约 =", deepCopy(oRes.data)); 
        }
        if (maxUserPositionAmount){
            updateCurrentPairSettings({
                maxUserPositionAmount, 
            });
        }
        const isActive = state === WavesContractStateAll.active;
        if (id){
            // ↓ 记录最新状态，例如 profit, lose, closed
            // ↓ 以及合约终止时的 pnl, roi 值（位于oRes.data中） 
            oPositionData_i.oStates[id] = oRes.data;
        }
        const topActiveShowing = oElementVisible.value.showTopActiveTable;
        const isActivePageDisplayed = (
            topActiveShowing // 顶部 active 页可见性 
            || oPositionData_i.currentTab === HistoryTabsEnum.active
        );
        const isClosedPageDisplayed = (
            // ↓ 位于 closed 页面才执行刷新数据操作 
            oPositionData_i.currentTab === HistoryTabsEnum.closed 
            // ↓ 合约已经关闭，或关闭进行中 
            && !isActive 
        ); 
        console.log('顶部+下方的个人数据页可见性', topActiveShowing, oPositionData_i.currentTab === HistoryTabsEnum.active); 
        if (isActivePageDisplayed){
            if (isActive) {
                // 执行判断到此，表示刚刚已建仓 or 修改了已建仓，↓用下边的方法刷新表数据 
                console.log("已建仓 or 修改了已建仓：", ); 
                // ↓ 这是原版的方案，当前已经有其它方式加载新数据，此处暂停（已经在建仓和修改之后自理加载事件）
                // ↓ 接上一行 2025.1.15 追加。突然发现不能暂停。不能在修改之后，即 updatePosition_gt() 内部加载表格，因为这样的话其它页的表仍然是旧的，应在下方刷新表格 
                oTabDataGetterFast.caller({
                    tabType: HistoryTabsEnum.active, 
                    forMobile: topActiveShowing, 
                });
            }
            // ↓ 进入 else 表示是 cashOutProcessing, cashed 等 
            else{
                if (state && state !== WavesContractStateAll.cashOutProcessing){ 
                    // ↓ 合同已经关闭时的专用延时，
                    await Sleep(500);
                }
                fnAppendOneFuturesUpdate_Q(oRes.data); 
                if (state !== WavesContractStateAll.cashOutProcessing){ 
                    // ↓ 延时调用，更新表格， 
                    clearTimeout(timer_A.value); 
                    timer_A.value = setTimeout(()=>{
                        oTabDataGetterSlow.caller({
                            tabType: HistoryTabsEnum.active,
                            forMobile: topActiveShowing,
                            // ↓ 执行清空 oPositionData_i.beforeRemovalInfo （有道理）
                            clean: true, 
                        }),
                        timer_A.value = null; 
                    }, 2_000); // 原版 2e3 === 2_000 
                }
            }
        } else if (isActive){
            // ↓ 后补。进入判断说明刚刚建仓，或修改仓，应切换到 active 页，会触发更新 
            oPositionData_i.currentTab = HistoryTabsEnum.active;
        }
        if (isClosedPageDisplayed){
            // ↓ 刷新页面数据 
            fnUpdateTabClosed(
                null,
                { tabType: HistoryTabsEnum.closed },
            );
        }
    };
    // ↓ public 
    // ↓ 接收 publicPosition 动态行数据 
    const subscribeOnPublicPosition_it = ()=>{ 
        oWavesWs.ON_WAVES_PUBLIC_UPDATED((oRes)=>{
            console.log("公共平仓信息：", deepCopy(oRes)); 
            if (oRes?._id){
                fnSaveLastPublicPosition_j(oRes); 
            }
        });
    }

    // ↓ public 
    // ↓ 导出： subscribeOnFuturesPositions 
    // ↓ 开启又订 
    const subscribeOnFuturesPositions_vt = () => {
        futuresUpdate_receiver();
        subscribeOnPublicPosition_it();
    }

    // ↓ public 
    // ↓ 取消订阅 public 页的新数据 
    const unsubscribeOnPublicPosition_St = ()=>{
        socket.off("publicPosition"); 
    };
    // ↓ 暂时停用 
    // watch(
    //     // ↓ 监听页签切换 💥 重点部分  
    //     () => oPositionData_i.currentTab, 
    //     () => {
    //         const toReStarter = (
    //             oPositionData_i.currentTab !== HistoryTabsEnum.active 
    //             ||
    //             !isMobile_S.value 
    //         );
    //         if (toReStarter){
    //             oTabDataGetterSlow.reStarter(); // 启动延时方法 
    //             oTabDataGetterFast.reStarter();
    //             return; 
    //         }
    //         // ↓ 专用于： 非移动端 && 大表后3页 closed, public, leaderboard  
    //         oTabDataGetterSlow.stopper(); // 关闭延时方法 
    //         oTabDataGetterFast.stopper(); 
    //         if (timer_A.value){
    //             clearTimeout(timer_A.value); 
    //             timer_A.value = null; 
    //             setLoading_q(false); 
    //         }
    //     }, 
    // );
    return {
        perMobPage: perMobPage_O, // computed 每页行数量 
        extraMobPerPage: iExtraMobPerPage_C, // 每页行数量（移动端特殊表） 
        positionsState: oPositionData_i, // 核心对象导出  
        // ↑ 数据 ------------------------------
        // ↓ 一些通信方法 ------------------------------------------- 
        createPosition: createPosition_dt, // 建仓 
        updatePosition: updatePosition_gt, // 建仓后修改 
        getPositions: getPositions_z, // 建仓后查询 💥 查询表格行数据 
        closePositionById: closePositionById_mt, // 平仓一项 
        closeAllPositions: closeAllPositions_Pt, // 平仓所有项 
        // -- ↑ 通信1: 头寸管理相关 -----------------------------------------------------   
        // -- ↓ 通信2：订阅数据与取消 --------------------------------------------  
        futuresUpdate_receiver, // 订阅 futuresUpdate（后补） 
        unSubscribeOnFuturesPositions: unSubscribeOnFuturesPositions_Tt, // 执行取消 futuresUpdate 
        subscribeOnPublicPosition: subscribeOnPublicPosition_it, // 订阅 publicPosition 
        unsubscribeOnPublicPosition: unsubscribeOnPublicPosition_St, // 执行取消 publicPosition 
        subscribeOnFuturesPositions: subscribeOnFuturesPositions_vt, // 双订 futuresUpdate, publicPosition 
        // ---------------------------------------------------- 
        setLoading: setLoading_q, 
        setCurrentTab: setCurrentTab_b,
        setIsNewCreated: setIsNewCreated_st, // 在建仓成功之后调用 
        setSelectedInstrument: setSelectedInstrument_w, // 修改币种 
        // -- ↓ 表格的行数据管理 --------------------------------------  
        setTableLines: setTableLines_m, 
        clearPositions: clearPositions_rt, // 定向清空表格行数据 
        // -- ↓ 页码管理 ---------------------------------------------  
        resetPagination: resetPagination_ft, // 重置页码 
        setPagination: setPagination_t, // 修改页码（桌面设备 
        setMobPagination: setMobPagination_o, // 修改页码（移动设备 
        clearTotalPositions: clearTotalPositions_lt, // 两类总行数值归零 
    }; 
};

// ↓ 控制各个元素可见性 
export const oElementVisible = computed(()=>{
    const globalStore = useGlobalStore(); 
    const oUserStore = useUserStore(); 
    const innerWidth = globalStore.innerWidth; 
    const iMiddle = 640; 
    // --------------------------------- 
    const outerTimePick = [
        innerWidth >= 1024,
        innerWidth >= iMiddle && innerWidth < 768, 
    ].some(Boolean);

    const outerFairness = [ 
        innerWidth >= iMiddle,
    ].some(Boolean);

    // ↓ 显示上方的 Active 表格 
    const showTopActiveTable = [
        import.meta.client,
        innerWidth < 768,
        oUserStore.isLoggedIn, // 登录用户专用 
    ].every(Boolean);
    
    const oResult = {
        outerTimePick,
        outerFairness,
        showTopActiveTable,
    };
    return oResult; 
});

